import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import OrderInfo from './OrderInfo'
import OrderState from './OrderState'

export default function Order(props) {
    const classes = useStyles();   

    return <div className={classes.orderContainer}>
        <div className={classes.coloredBorder} style={{ backgroundColor: props.productionOrder.productionOrderStatusForegroundColor }}></div>
        <OrderState productionOrder={props.productionOrder} {...props}></OrderState>
        <OrderInfo productionOrder={props.productionOrder} {...props}></OrderInfo>
    </div>
}

const useStyles = makeStyles({
    orderContainer: {
        backgroundColor: "white",
        borderRadius: "6px",
        height: '155px',
        boxShadow: "0px 3px 15px rgba(0,0,0,0.1)"

    },
    coloredBorder: {
        float: "left",
        width: "7px",
        height: "155px",
        borderRadius: "6px 0px 0px 6px",
        opacity: "0.28",
    }

});